export const WIDGET_ENTITY_NAME = 'Widget';
